<template>
  <div class="text-center my-5">
    <ProgressSpinner style="width:80px;height:80px" strokeWidth="3"/>
  </div>
</template>
